module.exports = "/src/views/player/help/images/gang.jpg";